import {
    OreButton,
    OreHeading,
    OreModal,
    OreModalBox,
    OreModalBoxBody,
    OreModalBoxFooter,
    OreStack,
    OreText
} from "@edenredespana/oreneta"
import { Trans, useTranslation } from "react-i18next"
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { navigationRoutes } from "@/Shared/ui/routers"
import { useNavigate } from "react-router-dom"

interface RegisterStepTwoEmailModalProps {
    isModalOpen: boolean
    setIsModalOpen: (isOpen: boolean) => void
}

export const NewTicketCancelModal = ({ isModalOpen, setIsModalOpen }: RegisterStepTwoEmailModalProps): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleExitClick = () => {
        setIsModalOpen(false)
        navigate(navigationRoutes.myTickets)
    }

    const handleCancelClick = () => {
        setIsModalOpen(false)
    }

    return (
        <OreModal open={isModalOpen} handleOnClose={() => setIsModalOpen(false)}>
            <OreModalBox size="medium" handleOnClose={() => setIsModalOpen(false)}>
                <OreModalBoxBody>
                    <OreHeading size="headline-lg">
                        {t(HelpCenterTranslations.cancelModal.title)}
                    </OreHeading>
                    <OreText>
                        <Trans t={t}>
                            {t(HelpCenterTranslations.cancelModal.description)}
                        </Trans>
                    </OreText>
                </OreModalBoxBody>
                <OreModalBoxFooter>
                    <OreStack direction="row" placeItems="center" placeContent="end" space="medium">
                        <OreButton onClick={handleCancelClick} size="small" category="secondary">
                            {t(HelpCenterTranslations.cancelModal.cancelButton)}
                        </OreButton>
                        <OreButton onClick={handleExitClick} size="small" category="primary">
                            {t(HelpCenterTranslations.cancelModal.exitButton)}
                        </OreButton>
                    </OreStack>
                </OreModalBoxFooter>
            </OreModalBox>
        </OreModal>
    )
}